export default __webpack_public_path__ + "static/banner-finance-redefining-work-baaeac1f11b19a6db8011be4e5e1920b.jpg";